import React from 'react';
import LoadingSpinner from '../../components/LoadingSpinner';
import ChatMessage from './ChatMessage';
import { useChatListScroll } from './useChatListScroll';

const SupportChatMessageList = ({ messages, loading, loadingOlder, hasMoreOlder, onLoadOlder }) => {
  const { listRef, contentRef, onScroll } = useChatListScroll({ messages, loading, onLoadOlder });

  if (loading && messages.length === 0) {
    return (
      <div className="flex-1 flex justify-center py-8 min-h-0">
        <LoadingSpinner error={[]} loading={true} />
      </div>
    );
  }

  return (
    <div ref={listRef} onScroll={onScroll} className="flex-1 min-h-0 overflow-y-auto p-4">
      <div ref={contentRef} className="space-y-3">
        {hasMoreOlder && (
          <div className="flex justify-center">
            <button
              type="button"
              onClick={onLoadOlder}
              disabled={loadingOlder}
              className="text-sm text-gray-500 hover:text-gray-800 disabled:opacity-60">
              {loadingOlder ? 'Загрузка…' : 'Более ранние сообщения'}
            </button>
          </div>
        )}
        {messages.length === 0 ? (
          <p className="text-center text-sm text-gray-500 py-6">Сообщений пока нет</p>
        ) : (
          messages.map((message) => <ChatMessage key={message.id} message={message} />)
        )}
      </div>
    </div>
  );
};

export default SupportChatMessageList;
